import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';
import * as TabelaAPI from '../../../api/tabela';

import Input from '../../form/Input';
import InputNumber from '../../form/InputNumber';
import TextArea from '../../form/TextArea';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';
import Select from '../../form/Select';

/* utils */
import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';

function Form({
    token,
    dados,
    setDados,
    empresaId,
    empresaIds,
    parametro,
    handleSubmit,

    btnText,
    caminhoVoltar,
    OptionsEmpresa,
    OptionsOperacao,
}) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    function handleChange(e) {
        const { name, value, type, checked } = e.target;
        const camposNumericos = ['manutencao', 'rendimento', 'tolerancia', 'capacidadeMinima', 'capacidadeMaxima', 'volume'];
        if (camposNumericos.includes(name)) {
            const valorFormatado = formatarNumeroDecimal(value);
            setDados({
                ...dados,
                [name]: valorFormatado,
            });
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }

    async function handleOnBlur(e) {
        const { name, value } = e.target;

        //verifica duplicidade
        if (name === 'descricao' && btnText === 'Cadastrar') {
            const duplicidade = await TabelaAPI.duplicidadeDescricao(dados.empresaId, 'Maquina', value);

            if (duplicidade?.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/Maquinas/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        if (!dados.operacaoId) {
            dados.operacaoId = parseInt(document.getElementById('operacaoId').value);
        }

        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Máquina</h1>
            <div>
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />
                <Select
                    text="Selecione a Operação"
                    name="operacaoId"
                    options={OptionsOperacao}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.operacaoId || ''}
                    required
                    notOptNull={true}
                />
                <Input
                    text="Descrição"
                    type="text"
                    name="descricao"
                    placeholder="Nome da máquina"
                    title="Digite o nome da máquina"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required={true}
                />
                <InputNumber
                    text="Manutenção"
                    type="text"
                    name="manutencao"
                    placeholder="tempo"
                    inputWidth="100px"
                    title="digite o tempo em meses para manutenção preventiva da máquina"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.manutencao ? formatarNumero(dados.manutencao) : ''}
                    required={true}
                />
                <InputNumber
                    text="Rendimento"
                    type="text"
                    name="rendimento"
                    placeholder="Rendimento"
                    inputWidth="100px"
                    title="digite o rendimento esperado da máquina conforme fabricante"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.rendimento ? formatarNumero(dados.rendimento) : ''}
                    required={true}
                />
                <InputNumber
                    text="Tolerância"
                    type="text"
                    name="tolerancia"
                    placeholder="Tolerância"
                    inputWidth="100px"
                    title="digite a tolerância em razão do rendimento da máquina"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.tolerancia ? formatarNumero(dados.tolerancia) : ''}
                    required={true}
                />
                <Checkbox
                    title="Quando marcado a forma de pagamento ou recebimento esta ATIVO"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <InputNumber
                    text="Capacidade Mínima"
                    type="text"
                    name="capacidadeMinima"
                    placeholder="kg"
                    inputWidth="100px"
                    title="digite a capacidade mínima de operação da máquina conforme o fabricante em quilos (kg)"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.capacidadeMinima ? formatarNumero(dados.capacidadeMinima) : ''}
                />
                <InputNumber
                    text="Capacidade Máxima"
                    type="text"
                    name="capacidadeMaxima"
                    placeholder="kg"
                    inputWidth="100px"
                    title="digite a capacidade máxima de operação da máquina conforme o fabricante em quilos (kg)"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.capacidadeMaxima ? formatarNumero(dados.capacidadeMaxima) : ''}
                />
                <InputNumber
                    text="Volume"
                    type="text"
                    name="volume"
                    placeholder="m³"
                    inputWidth="100px"
                    title="digite o volume máximo de operação da máquina,em metros cúbicos m³"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.volume ? formatarNumero(dados.volume) : ''}
                />
            </div>
            <div>
                <TextArea
                    text="Aplicação"
                    type="text"
                    name="aplicacao"
                    placeholder="Digite aqui detalhes da máquina"
                    title="aplicação da operação"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.aplicacao || ''}
                    textAlign="left"
                    linhas="4"
                    colunas="122"
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
